<template>
    <heads>
        <div class="grid grid-cols-2 gap-4">
            <div class="p-6 bg-white border-b border-gray-200 overflow-y-scroll h-screen-80 shadow-sm sm:rounded-lg">
                <p class="text-lg font-medium mb-4">List Salary Head</p>
                <breeze-table :searchable="true" :fields="fields" :items="salaryheads" :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Salary Head')" :canCreate="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Salary Head')">
                    <template #type="data">
                        {{data.item.type == 1 ?'Addition':'Subtraction'}}
                    </template>
                    <template #action="data">
                        <button-link v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Edit Salary Head')" :href="route('heads.salaryhead.edit',data.item.id)" >Edit</button-link>
                    </template>
                </breeze-table>
            </div>
            <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
                <loading :showLoading="form.processing" />
                <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                    <p class="text-lg font-medium mb-4">Add Salary Head</p>
                    <form @submit.prevent="submitForm" v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Salary Head')">
                        <div class="grid grid-cols-8 gap-4 mb-8">
                            <div class="col-span-8 sm:col-span-8">
                                <breeze-label :required="true" :value="'Title'"/>
                                <breeze-input required v-model="form.title" class="w-full"/>
                                <breeze-input-error :message="form.errors?form.errors.title:''" />
                            </div>
                            <div class="col-span-2 sm:col-span-2">
                                <breeze-label :value="'Addition'"/>
                                <input-checkbox type="radio" class="rounded-full" v-model="form.type" :checked="form.type == 1" value="1" />
                                <breeze-input-error :message="form.errors?form.errors.status:''" />
                            </div>
                            <div class="col-span-2 sm:col-span-2">
                                <breeze-label :value="'Subtraction'"/>
                                <input-checkbox type="radio" class="rounded-full" v-model="form.type" :checked="form.type == 0" value="0" />
                                <breeze-input-error :message="form.errors?form.errors.status:''" />
                            </div>
                        </div>
                        <breeze-button :disabled="form.processing">Submit</breeze-button>
                        <span v-if="form.recentlySuccessful" class="text-green-500 mx-4">Salary Head Added!</span>
                        <exception />
                    </form>
                    <div class="flex justify-center" v-else>
                        You have no permissions
                    </div>
                </div>
            </div>
        </div>
    </heads>
</template>

<script>
    import Heads from '@/Pages/Heads/Heads'
    import BreezeInput from '@/Components/Input'
    import BreezeLabel from '@/Components/Label'
    import ButtonLink from '@/Components/ButtonLink'
    import CardHeader from '@/Components/CardHeader'
    import { useForm } from '@inertiajs/inertia-vue3'
    import BreezeInputError from '@/Components/InputError'
    import BreezeButton from '@/Components/Button'
    import InputCheckbox from '@/Components/InputCheckbox'
    import Loading from '@/Components/Loading'
    import Exception from '@/Components/Exception'
    import BreezeTable from '@/Components/Table'

    export default {
        components: {
            Heads,
            BreezeInput,
            BreezeLabel,
            ButtonLink,
            CardHeader,
            BreezeInputError,
            BreezeButton,
            InputCheckbox,
            Loading,
            Exception,
            BreezeTable
        },
        props:['salaryheads'],
        data(){
            return{
                form: useForm({
                    title: '',
                    type: 1,
                }),
                fields:[{'key':'title','label':'Title'},{'key':'type','label':'Type'},{'key':'action','label':'Action'}]
            }
        },
        methods:{
            submitForm() {
                this.form.post(route('heads.salaryhead.store'),{
                    preserveScroll: true,
                    onSuccess: () => {this.form.reset(); location.reload()},
                });
            }
        }
    }
</script>
